import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const LandingSimple = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Load the SmartPlayer script
    const existingScript = document.querySelector('script[src*="converteai.net/lib/js/smartplayer"]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://scripts.converteai.net/lib/js/smartplayer-wc/v4/sdk.js';
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  const videoEmbedHTML = `
    <div id="ifr_698e3f4dceb26906d003b07e_wrapper" style="margin: 0 auto; width: 100%;">
      <div style="position: relative; padding: 56.25% 0 0 0;" id="ifr_698e3f4dceb26906d003b07e_aspect">
        <iframe 
          frameborder="0" 
          allowfullscreen 
          src="https://scripts.converteai.net/a5d4194b-bd13-448e-a24d-a7c1aacfe7d4/players/698e3f4dceb26906d003b07e/v4/embed.html"
          id="ifr_698e3f4dceb26906d003b07e" 
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border-radius: 16px;"
          referrerpolicy="origin"
        ></iframe>
      </div>
    </div>
  `;

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black flex flex-col">
      {/* Main Content */}
      <main className="flex-1 flex flex-col items-center justify-center px-4 py-12 md:py-20">
        <div className="max-w-4xl w-full text-center">
          
          {/* Title */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-white mb-4 md:mb-6 leading-tight">
            Cábala para Principiantes
          </h1>
          
          {/* Subtitle */}
          <p className="text-xl sm:text-2xl md:text-3xl text-amber-400 font-light mb-10 md:mb-14 max-w-3xl mx-auto leading-relaxed">
            Descubrí las claves ancestrales para transformar tu vida y conectar con tu propósito más profundo
          </p>
          
          {/* Video */}
          <div 
            className="mb-10 md:mb-14 rounded-2xl overflow-hidden shadow-2xl shadow-amber-500/10"
            dangerouslySetInnerHTML={{ __html: videoEmbedHTML }}
          />
          
          {/* CTA Button */}
          <button
            onClick={() => navigate('/reader/register')}
            className="group inline-flex items-center justify-center gap-3 bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white px-10 sm:px-14 py-5 sm:py-6 rounded-full text-xl sm:text-2xl font-bold transition-all duration-300 transform hover:scale-105 shadow-2xl shadow-amber-500/40"
          >
            <span>Quiero Empezar Ahora</span>
            <ArrowRight className="group-hover:translate-x-2 transition-transform" size={28} />
          </button>
          
          {/* Small text below CTA */}
          <p className="mt-6 text-gray-500 text-sm sm:text-base">
            30 páginas gratis · Sin tarjeta de crédito
          </p>
          
        </div>
      </main>
    </div>
  );
};

export default LandingSimple;
